import React, { useEffect, useState, useRef } from 'react'
import apiClient from '../../utils/api/apiClient'
import { APIEndpoints } from '../../utils/api/apiConfig'
import { Form } from 'react-bootstrap'
import styled from 'styled-components'
import ArraySelect from '../Select/ArraySelect'
import { useObserver } from 'mobx-react'
import { emptyGuid, isEmptyGuid } from '../../utils/emptyGuid'
import { t } from 'i18next'

const StyledWrapper = styled.div`


  .form-group {
    padding-left:20px;

    @media screen and (min-width: 460px) {
      width: auto;
    }
  }
`

const SupplierFilter = ({ supplierFilter, setSupplierFilter }) => {
  const [suppliers, setSuppliers] = useState([])
  let supplierId = useObserver(() => supplierFilter?.supplierId || emptyGuid)
  const mountedRef = useRef(true)

  useEffect(() => {
    apiClient.getJson(APIEndpoints.suppliers).then(resp => {
      if (!mountedRef.current) return null
      setSuppliers(resp)
    })
    return () => {
      mountedRef.current = false
    }
  }, [])

  const updateSupplierFilter = (displayName, supplierId = emptyGuid) => {
    let newObj = {
      displayName,
      supplierId,
    }
    setSupplierFilter(newObj)
  }

  const handleChange = e => {
    let newSupplierId = e.target.value

    if (!isEmptyGuid(newSupplierId)) {
        const supplierDisplayName = suppliers.find((obj) => obj.id === newSupplierId).displayName
        updateSupplierFilter(supplierDisplayName, newSupplierId)
    }
    else {
        updateSupplierFilter(null)
    }
  }

  return (
    <StyledWrapper>
      <div>
        <Form.Group className="mb-3">
          <ArraySelect
            options={suppliers}
            value={supplierId}
            onChange={handleChange}
            defaultOption={{ value: emptyGuid, name: t('employeesPage:filterNotSelected') }}
            returnEvent
          />
        </Form.Group>
      </div>
    </StyledWrapper>
  )
}

export default SupplierFilter